module.exports = __webpack_public_path__ + "static/media/hover-popup-active.0b5f37b6.svg";